<template>
    <div class="taker-feed-list">
        <div>
            <el-row :gutter="0">
                <el-col :lg="4" :md="24">
                    <div class="total-feed">
                        <div class="value">{{ filteredFeeds.length }} feed{{filteredFeeds.length > 1 ? 's' : ''}}</div>
                    </div>
                </el-col>
                <el-col :lg="20" :md="24">
                    <gcmcn-filters
                        :filter-values="[selectedSortType, searchFilter, selectedfeedStatus, dateRange]"
                        @reset-filters="resetFilters"
                        style="margin-top: 0;"
                    >
                        <dropdown
                            name="Sort"
                            :multiple="false"
                            :list="sortTypeList"
                            itemName="name"
                            itemValue="value"
                            :itemsSelected="selectedSortType.length > 0 ? [selectedSortType] : []"
                            @on-select-item="selectedSortType = $event"
                        ></dropdown>
                        <dropdown
                            name="Status"
                            :list="feedStatus"
                            itemName="name"
                            itemValue="value"
                            :itemsSelected="selectedfeedStatus"
                            @on-select-item="selectedfeedStatus = $event"
                        ></dropdown>
                        <date-picker-range ref="date-range" @on-range-selected="setDaterange"></date-picker-range>
                        <search-filter ref="search" @new-value="searchFilter = $event"></search-filter>
                    </gcmcn-filters>
                </el-col>
            </el-row>
            <el-alert
                v-if="filteredFeeds.length > 0"
                title="Rights cannot be managed on a finished feed"
                type="warning"
                effect="dark"
                :closable="false"
            ></el-alert>
            <template v-if="filteredFeeds.length > 0">
                <relatedFeed
                    v-for="(feed, index) in filteredFeeds"
                    :key="feed.uid"
                    :feed="feed"
                    :taker-uid="takerUid"
                    :broadcast-rights="broadcastRights"
                    @fetch-broadcastrights="refreshBroadcastRight"
                ></relatedFeed>
            </template>
            <template v-else>
                <div class="list-empty">No feed</div>
            </template>
        </div>
    </div>
</template>

<script>
import relatedFeed from './relatedFeed.vue';
import { mapGetters } from 'vuex';
import NsLoaderSpinner from '../../partials/ns-loader-template.vue';
import {
    Dropdown,
    DatePickerRange,
    SearchFilter,
    GcmcnFilters,
} from 'gcmcn-common';
import moment from 'moment';
export default {

    components: {
        relatedFeed,
        NsLoaderSpinner,
        GcmcnFilters,
        Dropdown,
        DatePickerRange,
        SearchFilter,
    },

    props: {
        feedsForTakerWithBroadcastRight: {
            type: Array,
            required: true
        },
        broadcastRights: {
            type: Array,
            required: true
        },
        events: {
            type: Array,
            required: true
        },
        takerUid: {
            type: String,
            required: true
        },
    },

    data: function(){
        return {
            retrievedFeeds: [],
            feedStatus: [
                {name: 'AVAILABLE', value: 'AVAILABLE'},
                {name: 'STARTING', value: 'STARTING'},
                {name: 'RUNNING', value: 'RUNNING'},
                {name: 'FINISHED', value: 'FINISHED'}],
            selectedfeedStatus: [],
            sortTypeList: [{name: 'asc', value:'asc'}, {name: 'dsc', value:'dsc'}],
            selectedSortType: '',
            dateRange: '',
            searchFilter: '',
        };
    },

    computed: {
        ...mapGetters([
            'takersByUid'
        ]),

        filteredFeeds (){
            let feeds = this.feedsForTakerWithBroadcastRight.slice().filter(feed => feed.archived === false);
            if(this.selectedfeedStatus.length > 0){
                feeds = feeds.filter((feed) => this.selectedfeedStatus.includes(feed.status));
            }

            if(this.dateRange.length > 0){
                let start = this.dateRange[0];
                let end = this.dateRange[1];
                feeds = feeds.filter((feed) => {
                    return moment(feed.start_date).isAfter(moment(start)) && moment(feed.end_date).isBefore(moment(end));
                });
            }
            if(this.selectedSortType.length > 0){
                feeds.sort((a,b) => {
                    return new Date(b.confirmed ? b.confirmed_start_date : b.start_date) - new Date(a.confirmed ? a.confirmed_start_date : a.start_date);
                });
                if(this.selectedSortType === 'asc'){
                    feeds.reverse();
                }
            }
            if(this.searchFilter.length > 0){
                let searchFilter = this.searchFilter.toLowerCase()
                feeds = feeds.filter((feed) => feed.display_name.toLowerCase().includes(searchFilter) ||
                    this.events.find((ev) => ev.uid === feed.event_uid).name.toLowerCase().includes(searchFilter)
                );
            }
            return this.$store.getters.orderingFeeds(feeds);
        },
    },

    mounted (){
    },

    methods: {
        setDaterange (val){
            this.$set(this, 'dateRange', val);
        },
        resetFilters (){
            this.$set(this, 'selectedfeedStatus', []);
            this.selectedSortType = '';
            this.$refs.search.clear();
            this.$refs['date-range'].clear();
        },

        refreshBroadcastRight (){
            this.$emit('fetch-broadcastrights');
        },
    },
};
</script>

<style lang="scss">
.taker-feed-list{
    .total-feed{
        font-weight: bold;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/page/Takers/takerRelatedFeedsList.vue